import React from "react";
import { buildTrendRows, sumTrendRows } from "./jentikTrend";

const JentikTrendTable = ({ data, indicator }) => {
  const rows = buildTrendRows(indicator, data);
  const total = sumTrendRows(indicator, data);

  if (indicator === "indikator_31") {
    return (
      <div className="table-table-responsive" style={{ marginTop: "2rem" }}>
        <table>
          <thead>
            <tr>
              <th>Bulan</th>
              <th>Jumlah TP Disurvei</th>
              <th>TP Masih Ada</th>
              <th>TP Positif</th>
              <th>IH (%)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.bulan}>
                <td>{row.label}</td>
                <td>{row.jumlah_tp_disurvei}</td>
                <td>{row.tp_masih_ada}</td>
                <td>{row.tp_positif}</td>
                <td>{row.ih_percent.toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr
              style={{
                fontWeight: "bold",
                backgroundColor: "#43766C",
              }}
            >
              <td style={{ color: "#FFF" }}>Total</td>
              <td style={{ color: "#FFF" }}>{total.jumlah_tp_disurvei}</td>
              <td style={{ color: "#FFF" }}>{total.tp_masih_ada}</td>
              <td style={{ color: "#FFF" }}>{total.tp_positif}</td>
              <td style={{ color: "#FFF" }}>{total.ih_percent}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  if (indicator === "indikator_32") {
    return (
      <div className="table-table-responsive" style={{ marginTop: "2rem" }}>
        <table>
          <thead>
            <tr>
              <th>Tanggal Kunjungan</th>
              <th>Total Kunjungan</th>
              <th>TP Masih Ada</th>
              <th>TP Positif</th>
              <th>TP Diintervensi</th>
              <th>IH (%)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.label}</td>
                  <td>{row.total_kunjungan}</td>
                  <td>{row.tp_masih_ada}</td>
                  <td>{row.tp_positif}</td>
                  <td>{row.tp_diintervensi}</td>
                  <td>{row.ih_percent.toFixed(1)}%</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  Tidak Ada Data
                </td>
              </tr>
            )}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr
                style={{
                  fontWeight: "bold",
                  backgroundColor: "#43766C",
                }}
              >
                <td style={{ color: "#FFF" }}>Total</td>
                <td style={{ color: "#FFF" }}>{total.total_kunjungan}</td>
                <td style={{ color: "#FFF" }}>{total.tp_masih_ada}</td>
                <td style={{ color: "#FFF" }}>{total.tp_positif}</td>
                <td style={{ color: "#FFF" }}>{total.tp_diintervensi}</td>
                <td style={{ color: "#FFF" }}>{total.ih_percent}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    );
  }

  return null;
};

export default JentikTrendTable;
